<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="neshs"
        :headers="headers"
        :rotina-id="ID_TELA_DE_NESH"
        :configurar="false"
        :loading="loading"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarNESH()"
        @update="(indice) => abrirDialogEditarNESH(indice)"
        @delete="(indice) => openDialogDeleteNESH(indice)"
      />
      <DialogDeEdicaoDeNESH
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :nesh-param="neshParam"
        :itens="itensParam"
        @confirmado="atualizarNESH"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteNESH" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="neshDelete">
            Tem certeza que deseja excluir a NESH <b> {{ neshDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteNESH = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerNESH">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import NESHService from '../../../services/nesh/nesh'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeNESH from '../../../components/neshs/DialogDeEdicaoDeNESH'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import NESH from '../../../models/nesh'
import NCMService from '../../../services/ncm/ncm'
import { ID_TELA_DE_NESH } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeNESH
  },

  props: ['buscaParam'],

  data: () => ({
    name: 'TelaDeNESH',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'NCM', value: 'ncm.codigo' }
    ],
    neshs: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    neshParam: new NESH(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteNESH: false,
    neshDelete: new NESH(),
    indiceNESHDelete: 0,
    itensNCM: [],
    ID_TELA_DE_NESH: ID_TELA_DE_NESH
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          NESHService.getById(this.$route.query.id).then((response) => this.neshs.push(response))
        } else {
          this.loadNESHs()
        }

        this.loadNCMs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar NESHs cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadNESHs() {
      this.loading = true
      const response = await NESHService.getAll()
      this.neshs = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    async loadNCMs() {
      const response = await NCMService.getAll()
      this.itensNCM = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    atualizarNESH(nesh) {
      if (!nesh) return

      const indice = this.neshs.findIndex((neshExistente) => neshExistente.id === nesh.id)

      if (indice === -1) {
        this.neshs.push(nesh)
        this.snackbar.snackTextParam = 'NESH criado com sucesso.'
      } else {
        this.neshs.splice(indice, 1, nesh)
        this.snackbar.snackTextParam = 'NESH atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteNESH(indice) {
      this.neshDelete = this.neshs[indice]
      if (!this.neshDelete.id) return

      this.indiceNESHDelete = indice
      this.dialogDeleteNESH = true
    },

    async removerNESH() {
      try {
        await NESHService.deleteById(this.neshDelete.id)
        this.snackbar.snackTextParam = 'NESH removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.neshs.splice(this.indiceNESHDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível excluir a NESH.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteNESH = false
    },

    abrirDialogCriarNESH() {
      this.operacao = 'adicionar'
      this.itensParam = { ncm: this.itensNCM }
      this.neshParam = new NESH()
      this.showDialogParam = true
    },

    abrirDialogEditarNESH(indice) {
      this.operacao = 'editar'
      this.itensParam = { ncm: this.itensNCM }
      this.neshParam = { ...this.neshs[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
